
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance",
      function () {
        return require("private-next-pages/insurance.js");
      }
    ]);
  